module.exports = __webpack_public_path__ + "static/media/weather5.1f3c1e24.jpg";